/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_OutcodeInputs */

const en_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Outcode (End)`)
};

const fr_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir l'outcode (fin)`)
};

const de_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Outcode (Ende)`)
};

const it_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta codice di uscita (fine)`)
};

const ru_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить исходящий код (Конец)`)
};

const es_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer código de salida (Fin)`)
};

const zh_cn2_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置输出码（结束）`)
};

const ja_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトコードの設定（終了）`)
};

const hi_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटकोड सेट करें (समाप्त)`)
};

const pt_pt2_shortcut_keys_name_set_outcode = /** @type {(inputs: Shortcut_Keys_Name_Set_OutcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir código de saída (Fim)`)
};

/**
* | output |
* | --- |
* | "Set Outcode (End)" |
*
* @param {Shortcut_Keys_Name_Set_OutcodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_outcode = /** @type {((inputs?: Shortcut_Keys_Name_Set_OutcodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_OutcodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_set_outcode(inputs)
	if (locale === "de") return de_shortcut_keys_name_set_outcode(inputs)
	if (locale === "it") return it_shortcut_keys_name_set_outcode(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_set_outcode(inputs)
	if (locale === "es") return es_shortcut_keys_name_set_outcode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_set_outcode(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_set_outcode(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_set_outcode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_set_outcode(inputs)
	return en_shortcut_keys_name_set_outcode(inputs)
});